import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useFaireProtection } from "@faire/retailer-visitor-shared/stores/domain/FaireProtection/useFaireProtection";
import { useMessengerFactory } from "@faire/retailer-visitor-shared/stores/MessengerFactory";
import { useFetchCachedBrandView } from "@faire/retailer-visitor-shared/views/brand/hooks/useFetchCachedBrandView";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { useMutation as useRetailerTokenRestrictionsMutation } from "@faire/web-api--source/api/retailer/retailerToken/retailer-restrictions/post-hooks";
import { trackZipCodeProtectionZipcodeprotectionmodalView } from "@faire/web-api--source/events/zipCodeProtection/view/zipcodeprotectionmodal";
import { IGetMessengerConversationsResponse } from "@faire/web-api--source/indigofair/data/IGetMessengerConversationsResponse";
import { IRetailerRestrictionsRequest } from "@faire/web-api--source/indigofair/data/IRetailerRestrictionsRequest";
import debug from "debug";
import { useEffect, useState } from "react";
var log = debug("BRAND_PAGE");
export var useBrandPageStateData = function(brandToken, brandViewDataPromise) {
    var _brandViewData_brand;
    var retailerToken = useRetailer().retailerToken;
    var _useFetchCachedBrandView = useFetchCachedBrandView(brandToken !== null && brandToken !== void 0 ? brandToken : "", brandViewDataPromise), brandViewData = _useFetchCachedBrandView.data, brandViewError = _useFetchCachedBrandView.error;
    var _useState = _sliced_to_array(useState(false), 2), hasFaireProtection = _useState[0], setHasFaireProtection = _useState[1];
    var _useState1 = _sliced_to_array(useState(undefined), 2), retailerRestrictions = _useState1[0], setRetailerRestrictions = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isFaireProtectionModalClosed = _useState2[0], setIsFaireProtectionModalClosed = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isFavoriteBrand = _useState3[0], setIsFavoriteBrand = _useState3[1];
    var mutate = useRetailerTokenRestrictionsMutation().mutate;
    var _useFaireProtection = useFaireProtection(), isBrandTokenForbidden = _useFaireProtection.isBrandTokenForbidden, forbiddenBrandTokens = _useFaireProtection.forbiddenBrandTokens;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var messengerStore = useMessengerFactory([
        "messengerStore"
    ]).messengerStore;
    useEffect(function() {
        if (retailerToken && isLoggedInRetailer) {
            mutate([
                retailerToken,
                IRetailerRestrictionsRequest.build({
                    brand_token: brandToken
                })
            ], {
                onSuccess: function(response) {
                    setRetailerRestrictions(response);
                },
                onError: function() {}
            });
        }
    }, [
        mutate,
        brandToken,
        retailerToken,
        isLoggedInRetailer
    ]);
    useEffect(function() {
        if (isBrandTokenForbidden(brandToken, {
            trackReason: true
        })) {
            setHasFaireProtection(true);
            log("zip code protected is true");
            trackZipCodeProtectionZipcodeprotectionmodalView(brandToken);
        }
    // forbiddenBrandTokens is a dependency of isBrandTokenForbidden
    }, [
        brandToken,
        isBrandTokenForbidden,
        forbiddenBrandTokens
    ]);
    useEffect(function() {
        if (brandViewError) {
            log("brand-view fetch failed");
            log(brandViewError);
            if (!brandViewData) {
                getLocationOrThrow().replace(faireBaseUrl());
            }
        }
    }, [
        brandViewData,
        brandViewError
    ]);
    useEffect(function() {
        if (isLoggedInRetailer) {
            log("update messenger context");
            messengerStore.setCurrentBrandContext(IGetMessengerConversationsResponse.ISimpleBrand.build(brandViewData === null || brandViewData === void 0 ? void 0 : brandViewData.brand));
        }
    }, [
        isLoggedInRetailer,
        messengerStore,
        brandViewData === null || brandViewData === void 0 ? void 0 : brandViewData.brand
    ]);
    useEffect(function() {
        var _brandViewData_brand;
        var _brandViewData_brand_is_following;
        setIsFavoriteBrand((_brandViewData_brand_is_following = brandViewData === null || brandViewData === void 0 ? void 0 : (_brandViewData_brand = brandViewData.brand) === null || _brandViewData_brand === void 0 ? void 0 : _brandViewData_brand.is_following) !== null && _brandViewData_brand_is_following !== void 0 ? _brandViewData_brand_is_following : false);
    }, [
        brandViewData === null || brandViewData === void 0 ? void 0 : (_brandViewData_brand = brandViewData.brand) === null || _brandViewData_brand === void 0 ? void 0 : _brandViewData_brand.is_following
    ]);
    return {
        brandToken: brandToken,
        hasFaireProtection: hasFaireProtection,
        setHasFaireProtection: setHasFaireProtection,
        isFaireProtectionModalClosed: isFaireProtectionModalClosed,
        setIsFaireProtectionModalClosed: setIsFaireProtectionModalClosed,
        isFavoriteBrand: isFavoriteBrand,
        setIsFavoriteBrand: setIsFavoriteBrand,
        retailerRestrictions: retailerRestrictions
    };
};
